import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {translate} from 'filters'
import {FormType} from "mixins/FormTypes"
import {Http} from "mixins/http"
import React, {createRef} from "react"
import AlertDanger from "../../../components/Alerts/AlertDanger"
import AlertSuccess from "../../../components/Alerts/AlertSuccess"
import Form from "../../../mixins/form"
import Trans from '../../../components/Trans'

type UpdatePasswordProps = {}

type UpdatePasswordState = {
  form: FormType
}

class UpdatePassword extends React.Component<UpdatePasswordProps, UpdatePasswordState> {
  private form: FormType = new Form({current_password: null, password: null, password_confirmation: null})
  private currentPasswordRef = createRef<HTMLInputElement>()
  private passwordRef = createRef<HTMLInputElement>()
  private passwordConfirmationRef = createRef<HTMLInputElement>()

  constructor(props: UpdatePasswordProps) {
    super(props)
    this.state = {
      form: this.form
    }
  }

  update = async (event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()

    this.form.current_password = this.currentPasswordRef.current ? this.currentPasswordRef.current.value : null
    this.form.password = this.passwordRef.current ? this.passwordRef.current.value : null
    this.form.password_confirmation = this.passwordConfirmationRef.current ? this.passwordConfirmationRef.current.value : null

    this.setState({
      form: this.form
    })

    await Http.put('/password', {state: this, form: this.state.form})
  }

  render() {
    const currentPasswordError = this.state.form.errors.get('current_password')
    const passwordError = this.state.form.errors.get('password')
    return (
      <div className="flex flex-col lg:flex-row flex-wrap w-full">
        <div className="flex flex-col lg:flex-row w-full">
          <div className="text-gray-600 font-semibold tracking-wide w-full lg:w-1/3 text-center lg:text-left flex flex-col">
            <div className="whitespace-no-wrap">
              <Icon icon="lock"/>
              <span> <Trans>Passwort</Trans></span>
            </div>
            <span className="white-space-wrap text-sm text-gray-500 italic mr-2"><Trans>Dein Passwort muss mindestens 6 Zeichen lang sein.</Trans></span>
          </div>
          <form className="w-full lg:w-2/3">
            {this.state.form.successful ?
              <AlertSuccess>
                <span><Trans>Ihr Passwort wurde erfolgreich gespeichert.</Trans></span>
              </AlertSuccess>
              : null}
            <div className="mt-4">
              <label className="block tracking-wide text-gray-600 font-semibold mb-1"><Trans>Aktuelles Passwort</Trans></label>
              <input name="current_password" ref={this.currentPasswordRef} placeholder="*************" type="password" className="appearance-none block w-full bg-gray-200 text-gray-800 border border-gray-200 rounded py-2 px-3 leading-tight hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300"/>
              {
                this.state.form.errors.has('current_password') &&
								<AlertDanger>
									<span>{currentPasswordError ? translate(currentPasswordError) : null}</span>
								</AlertDanger>
              }
            </div>
            <div className="mt-4">
              <label className="block tracking-wide text-gray-600 font-semibold mb-1"><Trans>Passwort</Trans></label>
              <input name="password" ref={this.passwordRef} placeholder="*************" type="password" className="appearance-none block w-full bg-gray-200 text-gray-800 border border-gray-200 rounded py-2 px-3 leading-tight hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300"/>
              {this.state.form.errors.has('password') ?
                <AlertDanger>
                  <span>{passwordError ? translate(passwordError) : null}</span>
                </AlertDanger>
                : null}
            </div>
            <div className="mt-4">
              <label className="block tracking-wide text-gray-600 font-semibold mb-1"><Trans>Passwort wiederholen</Trans></label>
              <input name="password_confirmation" ref={this.passwordConfirmationRef} placeholder="*************" type="password" className="appearance-none block w-full bg-gray-200 text-gray-800 border border-gray-200 rounded py-2 px-3 leading-tight hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300"/>
            </div>

            <div className="mt-4 flex justify-end">
              <button className={"rounded bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 font-semibold" + (this.state.form.busy ? ' cursor-not-allowed opacity-75' : '')} onClick={this.update}>
                {this.state.form.busy ?
                  <Icon icon="spinner" spin={true}/>
                  :
                  <Icon icon="lock"/>
                }
                <span> <Trans>Passwort ändern</Trans></span>
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default UpdatePassword
